import httpService from "V2.0/services/httpService";
import { useState } from "react";

export default function useWhatsAppMessageTemplates() {
  const [messageTemplates, setMessageTemplates] = useState([]);

  const fetchTemplates = async (projectId) => {
    try {
      const response = await httpService.get(
        `/whatsapp/manage/whitelabelGetTemplates/${projectId}`
      );
      const templates = response.data;
      setMessageTemplates(
        templates.map((template) => ({
          name: template.name,
          language: template.language,
        }))
      );
    } catch (error) {
      // showErrorToast(error, "Failed to get templates");
      console.error(error);
    }
  };

  return { messageTemplates, fetchTemplates };
}
